import { render, staticRenderFns } from "./DocumnetList.vue?vue&type=template&id=6bd33408&scoped=true"
import script from "./DocumnetList.vue?vue&type=script&lang=js"
export * from "./DocumnetList.vue?vue&type=script&lang=js"
import style0 from "./DocumnetList.vue?vue&type=style&index=0&id=6bd33408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd33408",
  null
  
)

export default component.exports